

<script>
export default {
    data: function() {
        return {
            MOBILE_SEND_VARIFYCODE_FREQUENTLY: 11050,        //获取验证操作过于频繁(多个号码), 需弹窗输入验证码
            EMPNO_PWD_FAIL_TOOMANY_TIMES: 2001, //密码输错多次
            MOBILE_PWD_FAIL_TOOMANY_TIMES: 11020,     //需强制校验图形验证码
            PWD_UPDATE_ERROR: 13010,         //密码修改失败

            //m站
            MOBILE_UNREGISTER: 10003,        //手机号未注册
            MOBILE_PWD_ERROR: 10001,         //密码错误
        }
    }
}
</script>


// WEBPACK FOOTER //
// ErrorCodeMixin.vue?f77be81c